import { ValidationSchema } from '../../../../../../../validations/interfaces';
import { Validation } from '../../../../../../../validations/Validation';
import loanFormModel from '../../../../../../../components/loan_application/form_models/loanFormModel';
import { RELATED_PARTY_RELATIONSHIP } from '../../../../../../../constants';

const {
  formField: { principalRentOrOwn, principalIsPG, applicantSameAsPrincipal },
} = loanFormModel;

export class PrincipalRentOrOwnValidation implements ValidationSchema {
  public name = principalRentOrOwn.name;
  public label = principalRentOrOwn.label;
  public dependsOn: string[] = [
    principalIsPG.name,

    applicantSameAsPrincipal.name,
  ];
  public type = 'string';
  public required = {
    message: '',
    value: false,
  };
  public nullable = true;

  public when(
    principalIsPG: string,
    applicantSameAsPrincipal: string,
    schema,
    context
  ) {
    const isPrincipal =
      context.parent.relationship == RELATED_PARTY_RELATIONSHIP.PRINCIPAL;

    if (
      principalIsPG === 'Yes' &&
      applicantSameAsPrincipal === 'Yes' &&
      isPrincipal
    ) {
      return schema.required(principalRentOrOwn.requiredErrorMsg);
    }
    return schema;
  }
}
export default new Validation(new PrincipalRentOrOwnValidation());
